import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../api/quarkusApi';
import { updateOverDueFinancialStatus } from '../overDueFinancialStatus';

const EMPTY_SUMMARY = {
  incomes: [],
  totalAmount: '',
  totalAmountToBeReceived: '',
  totalAmountReceived: '',
};

export function useIncomes(selectedDate) {
  const navigate = useNavigate();

  const [summary, setSummary] = useState(EMPTY_SUMMARY);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchIncomes = useCallback(() => {
    setLoading(true);
    setError(null);
    updateOverDueFinancialStatus()
      .then(() =>
        quarkusApi.get('/financial/incomes', {
          headers: { Authorization: sessionStorage.getItem('token') },
          params: { selectedDate: selectedDate.format('YYYY/MM') },
        }),
      )
      .then((returnFromApi) => setSummary(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [selectedDate, navigate]);

  useEffect(() => {
    fetchIncomes();
  }, [fetchIncomes]);

  return { ...summary, isLoading, error, refetch: fetchIncomes };
}
